export const DEFAULT_LOCALE = {
  language: 'English (US)',
  location: 'USA',
  locale: 'en-US',
};

// The locales list should match with

export const locales = [
  {
    ...DEFAULT_LOCALE,
  },
  {
    language: 'English (GB)',
    location: 'GB',
    locale: 'en-GB',
  },
  {
    language: 'English (AU)',
    location: 'Australia',
    locale: 'en-AU',
  },
  {
    language: 'English (CA)',
    location: 'Canada',
    locale: 'en-CA',
  },
  {
    language: 'Chinese (Simplified)',
    location: 'China',
    locale: 'zh-CN',
  },
  {
    language: 'Chinese (Traditional)',
    location: 'Hong Kong',
    locale: 'zh-HK',
  },
  {
    language: 'Danish',
    location: 'Denmark',
    locale: 'da-DK',
  },
  {
    language: 'Dutch (NL)',
    location: 'The Netherlands',
    locale: 'nl-NL',
  },
  {
    language: 'Finnish',
    location: 'Finland',
    locale: 'fi-FI',
  },
  {
    language: 'French (CA)',
    location: 'Canada',
    locale: 'fr-CA',
  },
  {
    language: 'French (FR)',
    location: 'French',
    locale: 'fr-FR',
  },
  {
    language: 'German (DE)',
    location: 'Germany',
    locale: 'de-DE',
  },
  {
    language: 'Italian (IT)',
    location: 'Italy',
    locale: 'it-IT',
  },
  {
    language: 'Japanese',
    location: 'Japan',
    locale: 'ja-JP',
  },
  {
    language: 'Korean',
    location: 'Korea',
    locale: 'ko-KR',
  },
  {
    language: 'Luxembourgish',
    location: 'Luxembourg',
    locale: 'lb-LU',
  },
  {
    language: 'Portuguese (BR)',
    location: 'Brazil',
    locale: 'pt-BR',
  },
  {
    language: 'Portuguese (PT)',
    location: 'Portugal',
    locale: 'pt-PT',
  },
  {
    language: 'Spanish (CO)',
    location: 'Colombia',
    locale: 'es-CO',
  },
  {
    language: 'Spanish (ES)',
    location: 'Spain',
    locale: 'es-ES',
  },
  {
    language: 'Spanish (MX/Latin Am)',
    location: 'Mexico',
    locale: 'es-MX',
  },
  {
    language: 'Swedish (SE)',
    location: 'Sweden',
    locale: 'sv-SE',
  },
  {
    language: 'Thai',
    location: 'Thailand',
    locale: 'th-TH',
  },
  {
    language: 'Turkish',
    location: 'Türkiye',
    locale: 'tr-TR',
  },
];
